import { FC, ReactNode } from 'react';
import { IoClose } from 'react-icons/io5';

import { ActionIcon, Box, Modal, ModalProps, Text } from '@mantine/core';

import { useIsMobile } from 'hooks/use-is-mobile';

import cx from './ProfileModal.module.scss';

const ProfileModal: FC<{
    opened: boolean;
    onClose: () => void;
    eyebrow?: ReactNode;
    eyebrowIcon?: ReactNode;
    title: ReactNode;
    size?: ModalProps['size'];
    children: ReactNode;
}> = ({ opened, onClose, eyebrow, eyebrowIcon, title, size = 'xl', children }) => {
    const isMobile = useIsMobile('sm');

    return (
        // Modal.Root skips the theme's Modal defaults, so repeat its zIndex to stay above the AppShell header
        <Modal.Root opened={opened} onClose={onClose} size={size} fullScreen={isMobile} zIndex={204}>
            <Modal.Overlay />
            <Modal.Content className={cx.content}>
                <Modal.Header className={cx.header}>
                    <Box className={cx.heading}>
                        {eyebrow && (
                            <Box className={cx.eyebrow}>
                                {eyebrowIcon && <Box className={cx.eyebrowIcon}>{eyebrowIcon}</Box>}
                                <Text component="span" className={cx.eyebrowText}>
                                    {eyebrow}
                                </Text>
                            </Box>
                        )}
                        <Modal.Title className={cx.title}>{title}</Modal.Title>
                    </Box>

                    <ActionIcon color="black" radius="xl" size="lg" onClick={onClose} aria-label="Close">
                        <IoClose size={20} />
                    </ActionIcon>
                </Modal.Header>

                <Modal.Body className={cx.body}>{children}</Modal.Body>
            </Modal.Content>
        </Modal.Root>
    );
};

export { ProfileModal };
